module.exports = __webpack_public_path__ + "img/Parents-bro1.0ad6c524.svg";